import React, { useState, useEffect, useCallback } from 'react';
import PublicEventsSection from './PublicEventsSection';
import IntentSegment from './components/IntentSegment';
import { useAuth } from '../../contexts/AuthContext';
import {
  EXPERIMENT_INTENT_SEGMENT,
  isExperimentEnabled,
} from '../../services/users/experiments';
import { buildWebsiteSchema, setJsonLdScript } from '../../services/seoSchema';
import heroPoster from './assets/web-banner.png';
import '../../styles/public.css';

const PAGE_TITLE = 'Sarajevo Events & Things to Do | MapToBe';

const LandingPage = () => {
  const { userProfile } = useAuth();
  const [upcomingTotal, setUpcomingTotal] = useState(0);
  const [hasMoreEvents, setHasMoreEvents] = useState(false);
  const [presetCategories, setPresetCategories] = useState(null);
  const showIntentSegment = isExperimentEnabled(userProfile, EXPERIMENT_INTENT_SEGMENT);

  const handleTotalCount = useCallback((n, hasMore = false) => {
    setUpcomingTotal(n);
    setHasMoreEvents(hasMore);
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;
    setJsonLdScript('m2b-website-schema', buildWebsiteSchema());

    return () => {
      document.title = prevTitle;
      setJsonLdScript('m2b-website-schema', null);
    };
  }, []);

  return (
    <>
      {/* Poster hero */}
      <section className="hero-poster-wrap" aria-label="MapToBe poster">
        <div className="hero-poster">
          <img
            className="hero-poster__img"
            src={heroPoster}
            alt="MapToBe — Urban Guide to Sarajevo"
            fetchpriority="high"
            decoding="async"
            width={1280}
            height={434}
          />
        </div>
      </section>

      {showIntentSegment ? (
        <div className="public-container public-section">
          <IntentSegment onPresetCategories={setPresetCategories} />
        </div>
      ) : null}

      {/* Upcoming events */}
      <div className="public-container public-section">
        <PublicEventsSection
          onTotalCount={handleTotalCount}
          presetCategories={showIntentSegment ? presetCategories : null}
        />
      </div>

      {/* Stats — below the event list */}
      <div className="stats-bar public-container">
        <div className="stat-item">
          <div className="stat-number">
            {upcomingTotal > 0
              ? hasMoreEvents
                ? `${upcomingTotal}+`
                : upcomingTotal
              : '—'}
          </div>
          <div className="stat-label pub-mono">Upcoming events</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">1</div>
          <div className="stat-label pub-mono">City</div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
